import type { FieldIndentifier } from "@packages/lib";
import { useConfigStore } from "./store";

export const useOptionLabel = (field: FieldIndentifier, optionId: string | null | undefined) =>
  useConfigStore((state) => state.getOptionLabel(field, optionId));
